module.exports = __webpack_public_path__ + "static/media/105.220beee8.jpg";